import emptyCart from '../../../assets/emptyCart.png';
import Spinner from 'components/contentLoader/spinner';

export type PaidListProps = {
    paidList?: Array<Record<string, unknown>>;
    isLoading?: boolean;
};

export default function PaidList({ paidList, isLoading }: PaidListProps) {
    const couponList =
        paidList && paidList.length
            ? paidList.map((listItem, index) => (
                  <div className="row Mb-B10" key={index}>
                      <div className="col-sm-12 col-md-12 col-lg-12" style={{ padding: '0px 10px' }}>
                          <div style={{ padding: '5px 0px' }}>
                              <div className="row" style={{ paddingBottom: '5px', borderBottom: '1px solid #d5d5d5' }}>
                                  <div className="col-sm-12 col-md-12 no-Pd">
                                      <div className="flex-container-grid">
                                          <div className="maint-reduce-text">
                                              Reduce Maintenance of
                                              <div className="card-text h7-text ">{listItem.CreatedMonth as string}</div>
                                          </div>

                                          <div>
                                              <div className="card-text" style={{ padding: '5px 0px 0px' }}>
                                                  {listItem.CreatedDate as string}
                                              </div>
                                              <div className="card-text h9-text" style={{ textAlign: 'right' }}>
                                                  ₹{listItem.RewardPoint as string}
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              ))
            : !isLoading
              ? (
                    <>
                        <img src={emptyCart} className="emptyCart-img" alt="" />
                        <div className="emptyCart-txt">Oops ! No item in Reward...</div>
                    </>
                )
              : null;

    return (
        <div>
            <section className="rewardCardSection">
                {couponList}
                {isLoading ? <Spinner /> : null}
            </section>
        </div>
    );
}
